import { render, staticRenderFns } from "./needLoginPopup.vue?vue&type=template&id=6d450ea6"
import script from "./needLoginPopup.vue?vue&type=script&lang=js"
export * from "./needLoginPopup.vue?vue&type=script&lang=js"
import style0 from "./needLoginPopup.vue?vue&type=style&index=0&id=6d450ea6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports